export const ATTR_GECKO_PAGE_IMAGE_DOCUMENT_ID =
  'gecko.page_image.document_id' as const
export const ATTR_GECKO_PAGE_IMAGE_PAGE_NUMBER =
  'gecko.page_image.page_number' as const
export const ATTR_GECKO_PAGE_IMAGE_SURFACE = 'gecko.page_image.surface' as const
export const ATTR_GECKO_PAGE_IMAGE_SOURCE = 'gecko.page_image.source' as const
export const ATTR_GECKO_PAGE_IMAGE_OUTCOME = 'gecko.page_image.outcome' as const
export const ATTR_GECKO_PAGE_IMAGE_REASON = 'gecko.page_image.reason' as const
export const ATTR_GECKO_PAGE_IMAGE_IS_CURRENT_PAGE =
  'gecko.page_image.is_current_page' as const
export const ATTR_GECKO_PAGE_IMAGE_RETRIED = 'gecko.page_image.retried' as const
